import NetInfo from "./services/netinfo/netinfo";

const localState = {
  flushing: false,
};
const queue = [];

const flush = async () => {
  // Mark the start
  localState.isFlushing = true;

  const entry = queue.shift();

  if (entry) {
    // Await the function
    await fetch(entry[0], entry[1]);

    // Continue flushing the queue
    flush();
  } else {
    localState.isFlushing = false;
  }
};

const consume = async () => {
  const netinfo = await NetInfo.fetch();
  const isConnected =
    netinfo.isInternetReachable || localState.isInternetReachable;

  if (isConnected) {
    // setTimeout here is used as a way to schedule the _flush_ call
    // to the next call stack/tick
    // TODO: (cristian) Need to enable this once bulk_updates is in sync as well
    // setTimeout(flush);
    flush();
  } else {
    // TODO
    // Store the queue to the storage
  }
};

// Listen to the state change
NetInfo.addEventListener((state) => {
  // Get the new state
  Object.assign(localState, state);

  // TODO
  // Read the stored queue from the storage
  // so we can consume it

  // Consume the queue
  consume();
});

/**
 * Handles the pushing to the queue and calls the consume method
 * @private
 * @param {Array} entry An entry in form of a tuple
 */
const addToQueue = (entry) => {
  queue.push(entry);
  consume();
};

/**
 * Schedule calls for the time when the system has connectivity and can handle the sync.
 * @param {Function} fn Function to be called when times comes
 * @param {Array} args Arguments to be called the function with. Think `fn.apply(null, args);`
 */
export const schedule = async (url, args) => {
  addToQueue([url, args]);

  return Promise.resolve({
    status: "ok",
  });
};
